import React from 'react';
import {HeaderInvoice, HeaderFooterInvoice} from '../components/HeaderInvoice'
import {IInvoiceService} from "../../services/IInvoiceService";
import FooterInvoice from "../components/FooterInvoice";

export type ActivityProps = {
    readonly params?: any
    readonly useLocation?: any
    readonly navigateToPage?: (link: string) => void
    readonly getInvoice: IInvoiceService['getInvoice']
}

export type ActivityState = {
    readonly loading: boolean
    readonly error: boolean
    readonly invoice: any
}

export class Activity extends React.Component<ActivityProps, ActivityState> {
    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            error: false,
            invoice: null
        }
    }

    public async componentDidMount() {
        const {invoiceId} = this.props.params
        await this.onGetInvoice(invoiceId)
    }

    private readonly onGetInvoice = async (hash: string) => {
        try {
            const invoiceResponse = await this.props.getInvoice(hash, undefined);
            this.setState({
                ...this.state,
                loading: false,
                invoice: invoiceResponse.data
            });
        } catch (e) {
            this.setState({
                ...this.state,
                loading: false,
                error: true
            })
        }
    }

    closeActivity = () =>{
        const {invoiceId} = this.props.params
        this.props.navigateToPage && this.props.navigateToPage(`/${invoiceId}${this.props.useLocation.search}`)
    }

    render() {
        const {loading, error, invoice} = this.state;
        return (
            <div>
                <HeaderInvoice loading={loading} error={error} hideAdminButtons={true} invoice={invoice}/>
                {!loading && !error &&
                <div className="container">
                    <div className="row">
                        <div className="pay-ui clear clearfix invoice-activity">
                            <h2 className="invoice-activity-header">Invoice activity
                                <div onClick={this.closeActivity} data-testid={'close-activity'} className="cancel-pay icon-remove"></div>
                            </h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="pay-ui clear clearfix invoice-activity">
                            <div dangerouslySetInnerHTML={{__html: invoice.activity}}></div>
                        </div>
                    </div>
                </div>}
                <FooterInvoice country={invoice?.company?.country ?? ""}/>
                <HeaderFooterInvoice loading={loading} error={error} hideAdminButtons={true} invoice={invoice}/>
            </div>
        );
    }
}

export default Activity;
